<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button, RadioGroup, Radio } from "view-design";
import config from "@/../config";
import dayjs from "dayjs";
export default {
  extends: baseList,
  data() {
    return {
      table: {
        mname: "messageNotification",
        key: "id",
        url: {
          list: "/admin/system/information/list",
        },
        output: false,
      },
      menus: [],
      filters: [
        // {
        //   label: "时间",
        //   KeyEnter: this.search,
        //   name: "createTime",
        //   value: "",
        //   type: "datetimerangemonth",
        // },
      ],
      tableCols: [
        {
          type: "index",
          title: "序号",
          width: 80,
          align: "center",
        },
        {
          title: "消息内容",
          minWidth: 180,
          align: "left",
          render: (h, p) => {
            let item = p.row;
            return (
              <div
                style="color:#2a75ed;cursor: pointer;"
                onClick={() => {
                  this.toInfo(item);
                }}
              >
                {item.content}
              </div>
            );
          },
        },
        {
          title: "状态",
          width: 120,
          align: "left",
          render: (h, p) => {
            let item = p.row;
            return (
              <div style={item.state == 2 ? "color:#ff0000" : ""}>
                {item.state == 2 ? "未处理" : "已处理"}
              </div>
            );
          },
        },
      ],
    };
  },
  created() {
    this.getMessageNum();
  },
  methods: {
    async getMessageNum() {
      let res = await $utils.api.load(`/admin/system/information/count`, {}, "GET");
      if (res.code == 200) {
        const currentNum = localStorage.getItem("messageNum"); 
        if (currentNum !== res.data.toString()) {              
          localStorage.setItem("messageNum", res.data);        
          window.location.reload();                             // 刷新页面
        }
      }
    },
    toInfo(item) {
      console.log(item);
      switch (item.infoType) {
        case 1:
          $utils.url.push({
            name: "workOrder_info",
            query: {
              action: "edit",
              kv: item.workId,
              stateId: item.id,
            },
          });
          break;
        case 2:
          $utils.url.push({
            name: "recordInfo",
            query: {
              action: "edit",
              kv: item.workId,
              stateId: item.id,
            },
          });
          break;
        case 3:
          $utils.url.push({
            name: "Info_Task",
            query: {
              action: "view",
              kv: item.workId,
              stateId: item.id,
            },
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style></style>
